import { ScFormLogoHeader } from './styled';

export type TLogoHeader = 'black' | 'white';

interface IFormLogoHeaderProps {
  logoTheme?: TLogoHeader;
}

export const FormLogoHeader = ({
  logoTheme = 'white',
}: IFormLogoHeaderProps) => <ScFormLogoHeader logoTheme={logoTheme} />;
